<template>
  <div class="content has-text-centered">
    <p class="new-pamm-msg">
      {{$t('pamm_statistics_text')}}
    </p>

    <a
      href="https://pamm.eurotrader.com"
      target="_blank"
      class="t4b-portal-btn-link button is-primary is-halfwidth"
    >PAMM Clientarea (MT4)</a>

    <a
      href="https://pamm-mt5.eurotrader.com"
      target="_blank"
      class="t4b-portal-btn-link button is-primary is-halfwidth"
    >PAMM Clientarea (MT5)</a>
  </div>
</template>

<script>
export default {
  data() {
    return {}
  },
  mounted() {},
}
</script>

<style lang="scss" scoped>
@import '~bulma/sass/utilities/initial-variables';
@import '../../assets/css/variables';

p.new-pamm-msg {
  margin: 50px 0 50px 0;
}

a.t4b-portal-btn-link {
  margin: 10px;
}
</style>



// WEBPACK FOOTER //
// pamm-statistics.vue?0977f574